import { productFamilyCodes } from 'types/productFamilyCodes';

const memberProductFamilies = [productFamilyCodes.PUB, productFamilyCodes.EUROSTAR_LOYALTY];

export default memberProductFamilies;
